const initialState = {
  version: "0.97",
  saving: null,
  notification: "",
};

// -------------------------------------------------------
// -------------------------------------------------------
const reducer = (state = initialState, action) => {
  // -------------------------------------------------------
  switch (action.type) {
    case "SET_USER":
      return { ...state, uid: action.uid, email: action.email };
    case "SET_USER_DATA":
      return { ...state, meter: action.meter, plan: action.plan };
    case "SET_SAVING":
      return { ...state, saving: action.saving };
    case "SET_NOTIFICATION":
      return { ...state, notification: action.notification };

    default:
      return state;
  }
};

export default reducer;
